module.exports = __webpack_public_path__ + "img/13.14717fd6.jpg";